<template>
  <div>
    <counterparty-details-header :counterparty="counterparty" />

    <b-row class="mb-0">
      <b-col
        v-for="(rating, index) in counterparty.creditRatings.content"
        :key="index"
        cols="12"
        md="4"
      >
        <b-card>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <b-card-title class="mb-0">
              {{ rating.entityname }} Credit Ratings
            </b-card-title>
            <div class="font-small-2 text-muted">
              Last updated {{ rating.asofdate ? formatDate(rating.asofdate) : '-' }}
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-center flex-fill">
              <div class="text-muted font-small-2 mb-1">Long Term</div>
              <h4 class="mb-0">{{ rating.longtermrating }}</h4>
            </div>
            <div class="text-center flex-fill">
              <div class="text-muted font-small-2 mb-1">Derivative CR</div>
              <h5 class="mb-0">{{ rating.derivativecr }}</h5>
            </div>
            <div class="text-center flex-fill">
              <div class="text-muted font-small-2 mb-1">Deposit CR</div>
              <h5 class="mb-0">{{ rating.depositcr }}</h5>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <spot-price-chart v-if="counterparty.spotData" :spot-data="counterparty.spotData" />
    <b-card v-else>
      <b-card-text class="text-center text-muted">
        No spot price data available
      </b-card-text>
    </b-card>

    <category-product-data
      v-if="$route.params.cid"
      category="counterparty"
      :category-id="String($route.params.cid)"
      filter-key="counterparty"
      :filter-value="String($route.params.cid)"
    />
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardText, BRow, BCol,
} from 'bootstrap-vue'
import CategoryProductData from './CategoryProductData.vue'
import SpotPriceChart from './SpotPriceChart.vue'
import CounterpartyDetailsHeader from './CounterpartyDetailsHeader.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    CategoryProductData,
    SpotPriceChart,
    CounterpartyDetailsHeader,
  },
  data() {
    return {
      counterparty: {
        data: {
          companyName: '',
          sections: [],
        },
        spotData: null,
        creditRatings: {
          content: [
            {
              entityname: 'S&P', longtermrating: '-', derivativecr: '-', depositcr: '-', asofdate: '',
            },
            {
              entityname: "Moody's", longtermrating: '-', derivativecr: '-', depositcr: '-', asofdate: '',
            },
            {
              entityname: 'Fitch', longtermrating: '-', derivativecr: '-', depositcr: '-', asofdate: '',
            },
          ],
        },
        loading: false,
        error: false,
      },
    }
  },
  created() {
    this.getCategoryDataById()
  },
  methods: {
    getCategoryDataById() {
      if (!this.$route.params.cid) return

      this.counterparty.loading = true
      this.counterparty.error = false

      this.$http
        .get(`public.cfc?method=getCategoryDataById&category=counterparty&id=${this.$route.params.cid}`)
        .then(response => {
          console.log('Category Data by ID for counterparty:', response.data)

          // Extract counterparty information from sections
          if (response.data.sections && response.data.sections.content) {
            const companyNameEntry = response.data.sections.content.find(item => item.section === 'Company Name')
            this.counterparty.data.companyName = companyNameEntry ? companyNameEntry.entry : ''
            this.counterparty.data.sections = response.data.sections.content
          }

          // Extract spot data for chart
          if (response.data.SPOTDATA) {
            this.counterparty.spotData = response.data.SPOTDATA
          }

          // Extract credit ratings
          if (response.data.creditratings && response.data.creditratings.content) {
            // Merge API data with default structure
            const apiRatings = response.data.creditratings.content
            this.counterparty.creditRatings.content = this.counterparty.creditRatings.content.map(defaultRating => {
              const apiRating = apiRatings.find(r => r.entityname === defaultRating.entityname)
              if (apiRating) {
                return {
                  entityname: apiRating.entityname,
                  longtermrating: apiRating.longtermrating || '-',
                  derivativecr: apiRating.derivativecr || '-',
                  depositcr: apiRating.depositcr || '-',
                  asofdate: apiRating.asofdate || '',
                }
              }
              return defaultRating
            })
          }
        })
        .catch(error => {
          console.error('Error fetching category data by ID:', error)
          this.counterparty.error = error
        })
        .finally(() => {
          this.counterparty.loading = false
        })
    },
    formatDate(dateStr) {
      if (!dateStr) return 'N/A'
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
    },
  },
}
</script>
